/** @format */
import { request } from '@power/runtime-vue3';

// 查询用户列表
export function getUserList(query: any) {
	return request(
		{
			url: '/system/user/list',
			method: 'get',
			params: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询部门列表
export function getDeptList(query: any) {
	return request({
		url: '/system/dept/list',
		method: 'get',
		params: query,
	});
}

// 查询角色列表
export function getRoleList(query: any) {
	return request(
		{
			url: 'system/role/list',
			method: 'get',
			params: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
//用户管理-修改密码
export function editPassword(data: any) {
	return request({
		url: '/base/rbac/user/change/resetPwd',
		method: 'post',
		data,
	});
}
//用户管理-修改密码
export function changePassword(data: any) {
	return request(
		{
			url: '/base/rbac/user/change/passwd',
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
// 用户管理-获取默认的用户安全设置
export function getDefaultUserSecurity() {
	return request({
		url: '/base/system/userserSecurity/getDefaultUserSecurity',
		method: 'get',
	});
}
//登录时重置密码
export function ChangePassword(data: any) {
	return request({
		url: '/base/rbac/user/first/change/passwd',
		method: 'post',
		data,
	});
}
//用户登录-首次登录是否需要修改密码
export function InitLoginChangePassword(account) {
	return request({
		url: `/base/auth/firstLogin?account=${account}`,
		method: 'post',
	});
}
//判断最长使用期限是否过期
export function getExpireDate(account) {
	return request({
		url: `/base/auth/isExpired?account=${account}`,
		method: 'post',
	});
}

//意见反馈记录查询
export function getFeedBackList(data: any) {
	return request(
		{
			url: '/base/system/sysFeedbackRecords/page',
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
//增加意见
export function addFeedBack(data: any) {
	return request(
		{
			url: '/base/system/sysFeedbackRecords/add',
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
